export function PromptHistory({
  promptHistory,
  runPrompt,
}: {
  promptHistory?: string[];
  runPrompt: (prompt: string) => void;
}) {
  if (!promptHistory || !promptHistory.length) return null;

  return (
    <>
      <li className="ai">
        <div className="arrow-box">
          <div className="arrow-box-header">
            <span className="user">History</span>
          </div>
          {[...promptHistory].reverse().map((prompt, index) => (
            <button
              type="button"
              className="jr-ai-assist-button"
              key={index}
              onClick={() => runPrompt(prompt)}
            >
              <span className="jr-ai-assist-label">{prompt}</span>
            </button>
          ))}
        </div>
      </li>
    </>
  );
}
